/* eslint-disable no-case-declarations */
import actions from "./actions";
import initialState from "../../demoData/usersData.json";
import initialStateGroup from "../../demoData/usersGroupData.json";

const {
  LIST_MEMBERS_BEGIN,
  LIST_MEMBERS_SUCCESS,
  LIST_MEMBERS_ERR,
  GET_MEMBER_DETAILS_BEGIN,
  GET_MEMBER_DETAILS_SUCCESS,
  GET_MEMBER_DETAILS_ERR,
  GET_MEMBER_SUBSCRIPTIONS_BEGIN,
  GET_MEMBER_SUBSCRIPTIONS_SUCCESS,
  GET_MEMBER_SUBSCRIPTIONS_ERR,
  DELETE_MEMBER_BEGIN,
  DELETE_MEMBER_SUCCESS,
  DELETE_MEMBER_ERR,

  CREATE_DASHBOARD_ADMIN_BEGIN,
  CREATE_DASHBOARD_ADMIN_SUCCESS,
  CREATE_DASHBOARD_ADMIN_ERR,

  UPDATE_DASHBOARD_ADMIN_BEGIN,
  UPDATE_DASHBOARD_ADMIN_SUCCESS,
  UPDATE_DASHBOARD_ADMIN_ERR,

  BLOCK_GENERIC_USER_BEGIN,
  BLOCK_GENERIC_USER_SUCCESS,
  BLOCK_GENERIC_USER_ERR,
  UNBLOCK_GENERIC_USER_BEGIN,
  UNBLOCK_GENERIC_USER_SUCCESS,
  UNBLOCK_GENERIC_USER_ERR,
  GET_GENERIC_USER_DETAILS_BEGIN,
  GET_GENERIC_USER_DETAILS_SUCCESS,
  GET_GENERIC_USER_DETAILS_ERR,
} = actions;

const initState = {
  loadingCreateDashboardAdmin: false,
  errorCreateDashboardAdmin: "",
  loadingUpdateDashboardAdmin: false,
  errorUpdateDashboardAdmin: "",
  members: [],
  loadingGetMemberDetails: false,
  errorGetMemberDetails: "",
  memberDetails: {},

  loadingGetMemberSubscriptions: false,
  errorGetMemberSubscriptions: "",
  memberSubscriptions: [],

  totalMembers: 0,
  totalMembersPages: 0,

  loadingDeleteMember: false,
  errorDeleteMember: "",
  loadingBlockGenericUser: false,
  errorBlockGenericUser: null,
  loadingUnBlockGenericUser: false,
  errorUnBlockGenericUser: null,
  loadingGetGenericUserDetails: false,
  errorGetGenericUserDetails: null,
  genericUserDetails: {},
};

const membersReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_DASHBOARD_ADMIN_BEGIN:
      return {
        ...state,
        loadingCreateDashboardAdmin: true,
        errorCreateDashboardAdmin: "",
      };
    case CREATE_DASHBOARD_ADMIN_SUCCESS:
      return {
        ...state,
        members: [...state.members, data],
        loadingCreateDashboardAdmin: false,
        errorCreateDashboardAdmin: "",
      };
    case CREATE_DASHBOARD_ADMIN_ERR:
      return {
        ...state,
        errorCreateDashboardAdmin: err,
        loadingCreateDashboardAdmin: false,
      };

    case LIST_MEMBERS_BEGIN:
      return {
        ...state,
        loadingListMembers: true,
        errorListMembers: false,
        totalMembers: 0,
        totalMembersPages: 0,
      };
    case LIST_MEMBERS_SUCCESS:
      return {
        ...state,
        members: [...data.results],
        loadingListMembers: false,
        errorListMembers: null,
        totalMembers: data.total_count,
        totalMembersPages: data.total_pages,
      };
    case LIST_MEMBERS_ERR:
      return {
        ...state,
        errorListMembers: err,
        loadingListMembers: false,
        totalMembers: 0,
        totalMembersPages: 0,
      };

    case GET_MEMBER_SUBSCRIPTIONS_BEGIN:
      return {
        ...state,
        loadingGetMemberSubscriptions: true,
        errorGetMemberSubscriptions: false,
        totalMemberSubscriptions: 0,
        totalMemberSubscriptionsPages: 0,
      };
    case GET_MEMBER_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        memberSubscriptions: [...data.results],
        loadingGetMemberSubscriptions: false,
        errorGetMemberSubscriptions: null,
        totalMemberSubscriptions: data.total_count,
        totalMemberSubscriptionsPages: data.total_pages,
      };
    case GET_MEMBER_SUBSCRIPTIONS_ERR:
      return {
        ...state,
        errorGetMemberSubscriptions: err,
        loadingGetMemberSubscriptions: false,
        totalMemberSubscriptions: 0,
        totalMemberSubscriptionsPages: 0,
      };

    case GET_MEMBER_DETAILS_BEGIN:
      return {
        ...state,
        memberDetails: {},
        loadingGetMemberDetails: true,
        errorGetMemberDetails: null,
      };
    case GET_MEMBER_DETAILS_SUCCESS:
      return {
        ...state,
        memberDetails: data,
        loadingGetMemberDetails: false,
        errorGetMemberDetails: null,
      };
    case GET_MEMBER_DETAILS_ERR:
      return {
        ...state,
        memberDetails: {},
        loadingGetMemberDetails: false,
        errorGetMemberDetails: err,
      };

    case UPDATE_DASHBOARD_ADMIN_BEGIN:
      return {
        ...state,
        loadingUpdateDashboardAdmin: true,
        errorUpdateDashboardAdmin: false,
      };

    case UPDATE_DASHBOARD_ADMIN_SUCCESS:
      const updatedAdmins = state.members.map((admin) =>
        admin.account_id === data.account_id ? { ...admin, ...data } : admin
      );
      return {
        ...state,
        members: updatedAdmins,
        loadingUpdateDashboardAdmin: false,
        errorUpdateDashboardAdmin: null,
      };
    case UPDATE_DASHBOARD_ADMIN_ERR:
      return {
        ...state,
        errorUpdateDashboardAdmin: err,
        loadingUpdateDashboardAdmin: false,
      };

      const updatedAgentEntities = state.agentEntities.map((admin) =>
        admin.account_id === data.account_id ? { ...admin, ...data } : admin
      );
      return {
        ...state,
        agentEntities: updatedAgentEntities,
        loadingUpdateAgentEntity: false,
        errorUpdateAgentEntity: null,
      };

    case DELETE_MEMBER_BEGIN:
      return {
        ...state,
        loadingDeleteMember: true,
        errorDeleteMember: null,
      };
    case DELETE_MEMBER_SUCCESS:
      return {
        ...state,
        loadingDeleteMember: false,
        errorDeleteMember: null,
      };
    case DELETE_MEMBER_ERR:
      return {
        ...state,
        errorDeleteMember: err,
        loadingDeleteMember: false,
      };

    case BLOCK_GENERIC_USER_BEGIN:
      return {
        ...state,
        loadingBlockGenericUser: true,
        errorBlockGenericUser: null,
      };
    case BLOCK_GENERIC_USER_SUCCESS:
      return {
        ...state,
        loadingBlockGenericUser: false,
        errorBlockGenericUser: null,
      };
    case BLOCK_GENERIC_USER_ERR:
      return {
        ...state,
        errorBlockGenericUser: err,
        loadingBlockGenericUser: false,
      };
    case UNBLOCK_GENERIC_USER_BEGIN:
      return {
        ...state,
        loadingUnBlockGenericUser: true,
        errorUnBlockGenericUser: null,
      };
    case UNBLOCK_GENERIC_USER_SUCCESS:
      return {
        ...state,
        loadingUnBlockGenericUser: false,
        errorUnBlockGenericUser: null,
      };
    case UNBLOCK_GENERIC_USER_ERR:
      return {
        ...state,
        loadingUnBlockGenericUser: false,
        errorUnBlockGenericUser: err,
      };
    case GET_GENERIC_USER_DETAILS_BEGIN:
      return {
        ...state,
        genericUserDetails: {},
        loadingGetGenericUserDetails: true,
        errorGetGenericUserDetails: null,
      };
    case GET_GENERIC_USER_DETAILS_SUCCESS:
      return {
        ...state,
        genericUserDetails: data,
        loadingGetGenericUserDetails: false,
        errorGetGenericUserDetails: null,
      };
    case GET_GENERIC_USER_DETAILS_ERR:
      return {
        ...state,
        genericUserDetails: {},
        loadingGetGenericUserDetails: false,
        errorGetGenericUserDetails: err,
      };

    default:
      return state;
  }
};

const userGroupReducer = (state = initialStateGroup) => {
  return state;
};

export { membersReducer, userGroupReducer };
